import * as React from 'react';
export const SGSvg = React.forwardRef(function SGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M16 8v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8h16Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M14 14H2a2 2 0 0 1-2-2V8h1v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8h1v4a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 8V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M3.364 5.205c0 .75.606 1.36 1.356 1.363a1.691 1.691 0 0 1-1.015.342 1.705 1.705 0 1 1 0-3.41c.382 0 .73.13 1.015.342a1.363 1.363 0 0 0-1.356 1.363ZM9.02 5a.5.5 0 1 1-.04-1 .5.5 0 0 1 .04 1ZM7.5 4.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM7 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM6 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2.5.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z',
      }),
    ),
  );
});
SGSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SG = {
  category: 'flag',
  colorable: false,
  name: 'SG',
  svg: SGSvg,
};
